import axios from "axios";

// Create an axios instance with default configuration
const axiosInstance = axios.create({
  baseURL:process.env.REACT_APP_BASE_URL || "http://localhost:8000",
});

// Add interceptor to include the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = process.env.REACT_APP_AUTH_TOKEN;
    return config;
  },
  (error) => Promise.reject(error)
);



const saveToken = async (data,role) => {
  console.log("Saving data: ", data);
  localStorage.setItem("TOKEN", data.token);
  localStorage.setItem("USER_NAME", data.username);
  localStorage.setItem("ROLE",role);
  localStorage.setItem("ARTIST",JSON.stringify(data.artist));
  console.log("Saved data: ", data," role-",role);
}

export const registerUser = async (name, email, password) => {
  try {
    console.log("Registering user with data:", { name, email, password }, process.env.REACT_APP_BASE_URL, process.env.REACT_AUTH_TOKEN);
    const response = await axiosInstance.post("/register/", {
      "name": name,
      "email": email,
      "password": password,
    });
    await saveToken(response.data,"user");
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Registration failed";
  }
};




export const loginUser = async (email, password) => {
  try {
    const response = await axiosInstance.post("/login/", {
      "email": email,
      "password": password,
    });
    await saveToken(response.data,"user");
    return response.data; // Return the response data to the component
  } catch (error) {
    throw error.response.data?.message || "Login failed";
  }
};

export const admin_loginUser = async (username, password) => {
  try {
    const response = await axiosInstance.post("/admin_login/", {
      "username": username,
      "password": password,
    });
    await saveToken(response.data,"admin");
    return response.data; // Return the response data to the component
  } catch (error) {
    throw error.response.data?.message || "Login failed";
  }
};

export const sendLoginUserOtp = async (phone) => {
  try {
    const response = await axiosInstance.post("/auth/loginOtp/", {
      "mobile": phone
    });
    return response.data; // Return the response data to the component
  } catch (error) {
    throw error.response.data?.message || "Login Otp failed";
  }
};




export const logoutUser = async () => {
  try {
    localStorage.clear();
  } catch (error) {
    throw error.response?.data?.message || "Logout failed";
  }
};
